/** @format */

import {
  Button,
  ButtonSize,
  ButtonVariant,
  RadioInput,
} from "@roadflex/react-components-www";
import { useCaptureBasicInformation } from "@roadflex/react-hooks-www";
import Link from "next/link";
import { useRouter } from "next/router";
import { Dialog } from "primereact/dialog";
import { useState } from "react";

type Props = {
  showModal: string;
  setShowModal: (value: string) => void;
};

const StepValues = [
  {
    step: 0,
    id: "vehiclesInFleet",
    title: "How many vehicles are in your fleet?",
    helper: "Please select one",
    options: ["1 - 5", "6 - 25", "26 - 100", "100+"],
  },
  {
    step: 1,
    id: "monthlyFuelSpend",
    title: "What's your monthly fuel spend?",
    helper: "Please select one",
    options: [
      "$1 - $2,500",
      "$2,501 - $10,000",
      "$10,001 - $30,000",
      "$30,000+",
    ],
  },
  {
    step: 2,
    title: "",
    helper: "",
    options: [],
  },
];

export function SalesLeadModal({ showModal, setShowModal }: Props) {
  const renderHeader = <div className="text-base">Let's get started</div>;
  const [step, setStep] = useState(0);
  const router = useRouter();

  const {
    values,
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    isSubmitting,
    touched,
    setFieldValue,
    resetForm,
    ...rest
  } = useCaptureBasicInformation({
    initialValues: {
      email: "",
      vehiclesInFleet: "",
      monthlyFuelSpend: "",
    },
    onSubmit(res, err) {
      setShowModal(values.email);
      resetForm();
    },
  });

  return (
    <Dialog
      className=""
      headerClassName=""
      style={{ minWidth: "50vw", maxWidth: "50vw", fontFamily: "Inter" }}
      header={renderHeader}
      visible={showModal !== ""}
      onHide={() => setShowModal("")}
      closeOnEscape={true}
      closable={false}
    >
      <form className="w-full">
        {step === 0 && (
          <div>
            <div>Question {StepValues[step].step + 1}</div>
            <div className="mb-4">{StepValues[step].title}</div>
            <div className="mb-2 italic">{StepValues[step].helper}</div>
            <div className="flex flex-row w-full">
              <div className="flex justify-center w-1/2 mr-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                <RadioInput
                  id={StepValues[step].id}
                  name={StepValues[step].id}
                  type="radio"
                  value={StepValues[step].options[0]}
                  onChange={() => {
                    setFieldValue(
                      "vehiclesInFleet",
                      StepValues[step].options[0],
                    );
                    setStep(step + 1);
                  }}
                  variant="small"
                  label={StepValues[step].options[0]}
                  checked={
                    values.vehiclesInFleet === StepValues[step].options[0]
                  }
                  labelClass={"text-brown-500 w-full py-2"}
                  className={`hidden`}
                ></RadioInput>
              </div>
              <div className="flex justify-center w-1/2 ml-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                <RadioInput
                  id={StepValues[step].id}
                  name={StepValues[step].id}
                  type="radio"
                  value={StepValues[step].options[1]}
                  onChange={() => {
                    setFieldValue(
                      "vehiclesInFleet",
                      StepValues[step].options[1],
                    );
                    setStep(step + 1);
                  }}
                  variant="small"
                  label={StepValues[step].options[1]}
                  checked={
                    values.vehiclesInFleet === StepValues[step].options[1]
                  }
                  labelClass={"text-brown-500 w-full py-2"}
                  className={`hidden`}
                ></RadioInput>
              </div>
            </div>
            <div className="flex flex-row w-full my-2">
              <div className="flex justify-center w-1/2 mr-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                <RadioInput
                  id={StepValues[step].id}
                  name={StepValues[step].id}
                  type="radio"
                  value={StepValues[step].options[2]}
                  onChange={() => {
                    setFieldValue(
                      "vehiclesInFleet",
                      StepValues[step].options[2],
                    );
                    setStep(step + 1);
                  }}
                  variant="small"
                  label={StepValues[step].options[2]}
                  checked={
                    values.vehiclesInFleet === StepValues[step].options[2]
                  }
                  labelClass={"text-brown-500 w-full py-2"}
                  className={`hidden`}
                ></RadioInput>
              </div>
              <div className="flex justify-center w-1/2 ml-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                <RadioInput
                  id={StepValues[step].id}
                  name={StepValues[step].id}
                  type="radio"
                  value={StepValues[step].options[3]}
                  onChange={() => {
                    setFieldValue(
                      "vehiclesInFleet",
                      StepValues[step].options[3],
                    );
                    setStep(step + 1);
                  }}
                  variant="small"
                  label={StepValues[step].options[3]}
                  checked={
                    values.vehiclesInFleet === StepValues[step].options[3]
                  }
                  labelClass={"text-brown-500 w-full py-2"}
                  className={`hidden`}
                ></RadioInput>
              </div>
            </div>
          </div>
        )}
        {step === 1 && (
          <div>
            <div>Question {StepValues[step].step + 1}</div>
            <div className="mb-4">{StepValues[step].title}</div>
            <div className="mb-2 italic">{StepValues[step].helper}</div>
            <form className="w-full" onSubmit={handleSubmit}>
              <div className="flex flex-row w-full">
                <div className="flex justify-center w-1/2 mr-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                  <RadioInput
                    id={StepValues[step].id}
                    name={StepValues[step].id}
                    type="radio"
                    value={StepValues[step].options[0]}
                    onChange={() => {
                      setFieldValue(
                        "monthlyFuelSpend",
                        StepValues[step].options[0],
                      );
                      setFieldValue("email", showModal);
                      setStep(step + 1);
                    }}
                    variant="small"
                    label={StepValues[step].options[0]}
                    checked={
                      values.monthlyFuelSpend === StepValues[step].options[0]
                    }
                    labelClass={"text-brown-500 w-full py-2"}
                    className={`hidden`}
                  ></RadioInput>
                </div>
                <div className="flex justify-center w-1/2 ml-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                  <RadioInput
                    id={StepValues[step].id}
                    name={StepValues[step].id}
                    type="radio"
                    value={StepValues[step].options[1]}
                    onChange={() => {
                      setFieldValue(
                        "monthlyFuelSpend",
                        StepValues[step].options[1],
                      );
                      setFieldValue("email", showModal);
                      setStep(step + 1);
                    }}
                    variant="small"
                    label={StepValues[step].options[1]}
                    checked={
                      values.monthlyFuelSpend === StepValues[step].options[1]
                    }
                    labelClass={"text-brown-500 w-full py-2"}
                    className={`hidden`}
                  ></RadioInput>
                </div>
              </div>
              <div className="flex flex-row w-full my-2">
                <div className="flex justify-center w-1/2 mr-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                  <RadioInput
                    id={StepValues[step].id}
                    name={StepValues[step].id}
                    type="radio"
                    value={StepValues[step].options[2]}
                    onChange={() => {
                      setFieldValue(
                        "monthlyFuelSpend",
                        StepValues[step].options[2],
                      );
                      setFieldValue("email", showModal);
                      setStep(step + 1);
                    }}
                    variant="small"
                    label={StepValues[step].options[2]}
                    checked={
                      values.monthlyFuelSpend === StepValues[step].options[2]
                    }
                    labelClass={"text-brown-500 w-full py-2"}
                    className={`hidden`}
                  ></RadioInput>
                </div>
                <div className="flex justify-center w-1/2 ml-2 border-2 border-orange-200 rounded-md hover:bg-orange-200">
                  <RadioInput
                    id={StepValues[step].id}
                    name={StepValues[step].id}
                    type="radio"
                    value={StepValues[step].options[3]}
                    onChange={() => {
                      setFieldValue(
                        "monthlyFuelSpend",
                        StepValues[step].options[3],
                      );
                      setFieldValue("email", showModal);
                      setStep(step + 1);
                    }}
                    variant="small"
                    label={StepValues[step].options[3]}
                    checked={
                      values.monthlyFuelSpend === StepValues[step].options[3]
                    }
                    labelClass={"text-brown-500 w-full py-2"}
                    className={`hidden`}
                  ></RadioInput>
                </div>
              </div>
            </form>
          </div>
        )}

        {step === 2 && (
          <div>
            <div className="">
              <Button
                variant={ButtonVariant.Brown}
                onClick={() => {
                  router.push({
                    pathname: "/signup",
                  });
                  setShowModal("");
                  handleSubmit();
                }}
                className="!px-4 sm:!px-8 font-medium w-full"
                size={ButtonSize.Normal}
              >
                Apply Now
              </Button>
            </div>
            <div className="mt-2">
              <Button
                variant={ButtonVariant.AppOrange}
                onClick={() => {
                  router.push({
                    pathname: "/contact-us",
                  });
                  setShowModal("");
                  handleSubmit();
                }}
                className="!px-4 sm:!px-8 font-medium w-full"
                size={ButtonSize.Normal}
              >
                Schedule a Demo
              </Button>
            </div>

            <div className="mt-8">
              How does RoadFlex help you save?
              <div className="italic">
                <Link href="/in-the-news">
                  <a href="/in-the-news" className="text-orange-500">
                    Check our Press releases
                  </a>
                </Link>{" "}
              </div>
              <div className="italic">
                <Link href="/blog">
                  <a href="/blog" className="text-orange-500">
                    Check our Blogs
                  </a>
                </Link>{" "}
              </div>
            </div>
          </div>
        )}
      </form>
    </Dialog>
  );
}

export default SalesLeadModal;
